import { useLoad } from '@gogame/query';

import { loadConcept } from 'scenes/Gallery/GalleryPage/Concepts/sources/concepts';

import { model } from './queryKeyFactory';

export const useConcept = ({ id }, settings) => {
  return useLoad(model(id), () => loadConcept({ id }), settings);
};
